import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent14001 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]"> ISO 140</span>
                01:2015 CERTIFICATION
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              Corporate Social Responsibilities awareness is increasing amongst
              all stakeholders and EMS is core part of the CSR. Implementing an
              Environmental Management System gives companies a competitive
              edge. “Save the Environment ”This is the main theme of the ISO
              14001:2015 standard. To save the environment is the prima facie
              objectives of the corporates and industry. This is applicable to
              all type of the Industry which are polluting to the environment by
              their activities.This standard sets out the criteria for an
              environmental management system. It sets out a framework that an
              organization has to follow to implement the effective
              Environmental Management System. The Implementation of EMS provide
              a confidence in the mind of Management and Employees and
              stakeholders that Environmental hazards are taken care by the
              organization properly.
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent14001;
